import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SendMessage } from '../../../../core/src/lib/interface/conversation.interface';

@Injectable()
export class InboxSendMessageResolver {
  constructor(private router: Router) {}

  resolve(): SendMessage {
    return this.router.getCurrentNavigation().extras?.state as SendMessage;
  }
}
